import { Body2, Caption, Image, Responsive, useDeviceType } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { type FC } from 'react';

import { AwardCardTooltip } from '../AwardCardTooltip';

import styles from './AwardCard.css';

type TAwardCardProps = {
  title: string;
  image: string;
};

export const AwardCard: FC<TAwardCardProps> = ({ title, image }) => {
  const deviceType = useDeviceType();

  // Не поддерживаем адаптив, но сохраним код для будущего использования, если будем делать адаптив
  // const height = deviceType === 'desktop' ? 66 : 80;
  // const width = deviceType === 'desktop' ? 200 : 220;
  const height = 66;
  const width = 200;

  return (
    <AwardCardTooltip text={title}>
      <div className={styles['card']} data-testid="AwardCard">
        <div className={clsx(styles['image'], deviceType === 'desktop' && styles['image--desktop'])}>
          <Image
            alt={title}
            height={height}
            loading="lazy"
            objectFit="contain"
            preloader={false}
            src={image}
            width={width}
          />
        </div>
        <div className={styles['text']}>
          <div className={styles['text__inner']}>
            <Body2>{title}</Body2>
          </div>
        </div>
        <Responsive desktop>
          <div className={styles['overlay']}>
            <div className={styles['overlay__inner']}>
              <Caption>{title}</Caption>
            </div>
          </div>
        </Responsive>
      </div>
    </AwardCardTooltip>
  );
};
